/**
 *
 *@author zcc
 *@date 2022/3/16 15:51
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';
import { LoginServiceImpl } from '@/service/LoginServiceImpl';
import { ObserverService } from '@/service/ObserverService';

export class LoginViewModel extends BaseViewModel {
  dialogVisible = false;
  isLogin = true;
  isShowSuccess = false;
  showBtnLoading = false;

  email = '';
  password = '';
  tipText = '';

  enterKeyEvent(event: any) {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      this.handleLoginSubmitEvent();
    }
  }

  changeShowPage() {
    this.isLogin = !this.isLogin;
    this.tipText = '';
  }

  handleLoginSubmitEvent() {
    if (!this.checkEmail()) {
      return;
    }
    if (this.isLogin) {
      this.login().then();
      return;
    }
    this.getPasswrod().then();
  }

  async login() {
    if (!this.checkPassword()) {
      return;
    }
    this.showBtnLoading = true;
    let userInfo = null;
    try {
      userInfo = await LoginServiceImpl.getInstance().login(this.email, this.password);
      this.showBtnLoading = false;
      this.dialogVisible = false;
      this.$router
        .push({
          path: '/cms/home',
          query: {
            id: (userInfo as any).developerInfo.id,
            token: (userInfo as any).developerInfo.token
          }
        })
        .then();
      ObserverService.getInstance().getIsLoginObserver().next(true);
    } catch (e: any) {
      this.tipText = e.message;
      this.showBtnLoading = false;
    }
  }

  async getPasswrod() {
    this.showBtnLoading = true;
    try {
      await LoginServiceImpl.getInstance().forgetPassword(this.email);
      this.showBtnLoading = false;
      this.isShowSuccess = true;
    } catch (e: any) {
      this.tipText = e.message;
      this.showBtnLoading = false;
    }
  }

  gotoLogin() {
    this.isShowSuccess = false;
    this.isLogin = true;
  }

  dialogVis(val: boolean) {
    this.dialogVisible = val;
  }

  closeDialogEvent() {
    this.dialogVisible = false;
    this.isLogin = true;
    this.isShowSuccess = false;
    this.tipText = '';
    this.email = '';
    this.password = '';
    window.removeEventListener('keyup', this.enterKeyEvent, true);
  }

  opendDialogEvent() {
    window.addEventListener('keyup', this.enterKeyEvent, true);
  }

  checkEmail() {
    if (!this.email) {
      this.tipText = '邮箱不能为空';
      return false;
    }
    if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.email)) {
      this.tipText = '请输入正确的邮箱';
      return false;
    }
    this.tipText = '';
    return true;
  }

  checkPassword() {
    if (!this.password) {
      this.tipText = '密码不能为空';
      return false;
    }
    if (this.password.length < 6 || this.password.length > 16) {
      this.tipText = '请输入6-16位的密码';
      return false;
    }
    this.tipText = '';
    return true;
  }
}
